<script>

    import app from '../data/app.svelte.js';
    import { currentSession } from '../data/session.svelte.js';
    import { _ } from 'svelte-i18n';

    import Salon from './Salon.svelte';
    import Language from './Language.svelte';
    import ChatLauncher from './ChatLauncher.svelte';

    import Icon from './Icon.svelte';
    import closeIcon from '../assets/icons/close.svg?raw';

    let { children } = $props();

    /* The round AI launcher shows only on the booking selection steps — from the second
       step through confirmation. The welcome (first) step offers the assistant via an
       inline button instead (clearer what it does), and the chat/post-confirmation/error
       screens don't offer it. A confirmed session is finished, so it's hidden then too. */
    const LAUNCHER_STEPS = ['treatment', 'employee', 'schedule', 'customer', 'confirm'];

    let showLauncher = $derived(
        app.settings.widget.chat?.enabled
        && currentSession.status !== 'confirmed'
        && LAUNCHER_STEPS.includes(app.state.step)
    );

</script>

<main>
    <header>
        <Salon />

        {#if app.salon.website}
            <nav>
                <a href={app.salon.website} aria-label={$_('close')}>
                    <Icon data={closeIcon} />
                </a>
            </nav>
        {/if}

        <Language />
    </header>

    {@render children?.()}

    {#if showLauncher}
        <ChatLauncher />
    {/if}
</main>

<style>

    main {
        grid-column: 3;
        grid-row: 2;

        background: var(--title-color);
        color: var(--text-color);
        border-radius: var(--card-radius);
        box-shadow: 0 0 20px rgba(0,0,0,.15),0 20px 40px rgba(0,0,0,.05);

        position: relative;
        z-index: 1;
        
        display: grid;
        grid-template-rows: min-content 1fr;
        
        font-size: 1.1em;
    }

    @media (max-width: 600px) {
        main {
            border-radius: 0;
            margin-bottom: 0;
            padding-bottom: 4em;

            background: var(--background-color);
            box-shadow: none;

            z-index: 0;
            overflow: visible;
        }
    }


    header {
        grid-row: 1;
        grid-column: 1;

        position: relative;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        gap: 1em;
        
        border-radius: var(--card-radius) var(--card-radius) 0 0;

        padding: 1em 2em 1em 2em;
    }

    header * {
        margin: 0;
    }

    header nav {
        font-size: 0.85rem;
        justify-self: end;
    }

    header nav a {
        display: flex;
        border-radius: 4px;
        padding: 0.3em;
        position: relative; 
        right: -0.8em;
    }

    header nav :global(svg) {
        fill: #808080; 
    }

    header nav a:hover,
    header nav a:focus-visible {
        background: #00000022;
    }

    
    @media (max-width: 600px) {
        header {
            background: var(--title-color);
            border-radius: 0;

            position: sticky;
            top: 0;
            z-index: 999;
        }
    }

</style>